(function(){
    'use strict';

    var $smpHeader = $('.smp-header'),
        $smpLower = $smpHeader.find('.smp-header__lower'),
        $smpSearchBtn = $('.smp-js-smpsearch-btn'),
        $smpMobileBtn = $('.smp-js-smpmobile-btn');
  
        let $smpActives = '';
        let width = screen.width;

        if($smpHeader.length){

            $smpMobileBtn.click(function(){
                var $cur = $(this);
                var btnToggle = squiz.fn.smpToggleBtn($cur);

                $smpSearchBtn.removeClass('active');

                if(!btnToggle) {
                    document.body.classList.add('mobile-menu-open');
                    $smpLower.addClass('open');

                } else {
                    document.body.classList.remove('mobile-menu-open');
                    $smpLower.removeClass('open');
                    $smpActives = $smpLower.find('.active');
                    
                    for(let i = 0; i < $smpActives.length; i++) {
                        $smpActives[i].classList.remove('active');
                    }

                }

                return false;
            });

        }

}());
